import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const PointsDisplay = styled.div<{ $pointer: boolean }>`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  min-height: 32px;
  padding: 4px 12px 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  cursor: ${({ $pointer }) => ($pointer ? 'pointer' : 'default')};
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 0px 1px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
